export const PrepaidIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.33333 10H4.66667M14 5.99999H2M2 12V3.99999C2 3.82318 2.07024 3.65361 2.19526 3.52859C2.32029 3.40357 2.48986 3.33333 2.66667 3.33333H13.3333C13.5101 3.33333 13.6797 3.40357 13.8047 3.52859C13.9298 3.65361 14 3.82318 14 3.99999V12C14 12.1768 13.9298 12.3464 13.8047 12.4714C13.6797 12.5964 13.5101 12.6667 13.3333 12.6667H2.66667C2.48986 12.6667 2.32029 12.5964 2.19526 12.4714C2.07024 12.3464 2 12.1768 2 12Z"
            stroke="#A50FDA"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
